const validateFullName = (fullName: string) => {
  const fullNameRegex = /^[a-zA-Z ]{3,}$/;
  return fullNameRegex.test(fullName);
};

const validateCity = (City: string) => {
  const fullNameRegex = /^[a-zA-Z ]+$/;
  return fullNameRegex.test(City);
};

const validatePetBreed = (breed: string) => {
  const fullNameRegex = /^[a-zA-Z ]+$/;
  return fullNameRegex.test(breed);
};

const validateText = (breed: string) => {
  const fullNameRegex = /^[a-zA-Z ]+$/;
  return fullNameRegex.test(breed);
};

const validatePetName = (name: string) => {
  const fullNameRegex = /^[a-zA-Z ]+$/;
  return fullNameRegex.test(name);
};

const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
const validatePassword = (password: string) => {
  const passwordRegex =
    /^(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])(?=.*[0-9]).{8,}$/;
  return passwordRegex.test(password);
};

const validateConfirmNewPassword = (
  password: string,
  confirmPassword: string
) => {
  if (password !== confirmPassword) {
    return false;
  }
  return true;
};

const validateName = (Name: string) => {
  const nameRegex = /^[a-zA-Z. ]{3,}$/;
  return nameRegex.test(Name);
};

const validateAddress = (Address: string) => {
  const addressRegex = /^[#.0-9a-zA-Z\s,-]+$/;
  return addressRegex.test(Address);
};
const validateZipCode = (Number: string) => {
  const zipCodeRegex = /^(\d{4,9}(?:[-\s]\d{4})?)?$/;
  return zipCodeRegex.test(Number);
};
const validatePhone = (Number: string) => {
  const phoneRegex = /^\d{5,15}$/;
  return phoneRegex.test(Number);
};

export {
  validateFullName,
  validateAddress,
  validateZipCode,
  validatePhone,
  validateCity,
  validateName,
  validatePassword,
  validateEmail,
  validateConfirmNewPassword,
  validatePetBreed,
  validatePetName,
  validateText,
};
